// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__1OPvk","navText":"Navbar_navText__kd_PN","navLogo":"Navbar_navLogo__3VrYC","imgLogo":"Navbar_imgLogo__1XbS9"};